import {useTranslation} from 'react-i18next';
import {ChevronLeft} from 'lucide-react';
import {Button} from '@chekinapp/ui';

type Props = {
  onClick: () => void;
  disabled?: boolean;
};

function CardBackButton({onClick, disabled}: Props) {
  const {t} = useTranslation();

  return (
    <Button
      variant="link"
      onClick={onClick}
      disabled={disabled}
      className="mb-3 h-auto gap-1 p-0 text-[13px] font-semibold"
    >
      <ChevronLeft size={16} />
      {t('back')}
    </Button>
  );
}

export {CardBackButton};
